"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _components = require("../../components");

var _AttachedDocs = require("./AttachedDocs.styled");

var ListItem = function ListItem(_ref) {
  var item = _ref.item;
  var match = (0, _reactRouterDom.useMatch)();
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "".concat(match.pathname, "?attachment=").concat(item.id, "&type=").concat(item.mediaType.split('/')[1], "&title=").concat(item.title)
  }, /*#__PURE__*/_react.default.createElement(_AttachedDocs.ListItemWrapper, null, /*#__PURE__*/_react.default.createElement(_components.Icon, {
    title: item.mediaType
  }), /*#__PURE__*/_react.default.createElement("span", null, item.title)));
};

var _default = ListItem;
exports.default = _default;